import BackgroundOverlay from "components/loading/BackgroundOverlay";
import CloseButton from "components/buttons/CloseButton";
import ColorValue from "types/enums/ColorValue";
import FontClass from "types/enums/FontClass";
import ResponsiveContainer from "components/containers/ResponsiveContainer";
import TextButton from "components/buttons/TextButton";
import TextButtonTheme from "types/enums/TextButtonTheme";
import joinClasses from "utils/joinClasses";
import styles from "css/header/pre/MenuMobile.module.css";
import { useState } from "react";
import OutsideClickHideModal from "components/modal/OutsideClickHideModal";
import FORM_LINK from "constants/FormLink";

function Button({
  children,
  href,
}: {
  children: string;
  href: string;
}): JSX.Element {
  return (
    <TextButton
      buttonTheme={TextButtonTheme.Primary}
      fontClass={FontClass.NavLink}
      href={href}
      type="link_external"
    >
      {children}
    </TextButton>
  );
}

type Props = {
  onHide: () => void;
};

export default function MenuMobile({ onHide }: Props): JSX.Element {
  const [slideOutClassName, setSlideOutClassName] = useState<string>("");
  const [backgroundOverlayClassName, setBackgroundOverlayClassName] =
    useState<string>(styles.backgroundOverlayFadeIn);

  const onHideWithSlide = () => {
    setBackgroundOverlayClassName(styles.backgroundOverlayFadeOut);
    setSlideOutClassName(styles.slideOut);
    setTimeout(onHide, 600);
  };

  return (
    <OutsideClickHideModal hideModal={onHideWithSlide}>
      <div className={styles.containerOuter}>
        <BackgroundOverlay className={backgroundOverlayClassName} />
        <ResponsiveContainer
          className={joinClasses(styles.container, slideOutClassName)}
        >
          <div className={styles.textButtons}>
            <div className={styles.firstRow}>
              <CloseButton
                className={styles.closeButton}
                colorValue={ColorValue.Primary}
                isShown={false}
              />
              <Button href="mailto:matt@formfn.xyz">Contact</Button>
              <CloseButton
                className={styles.closeButton}
                colorValue={ColorValue.Primary}
                onClick={onHideWithSlide}
              />
            </div>
            <Button href={FORM_LINK}>Submit artist profile</Button>
          </div>
        </ResponsiveContainer>
      </div>
    </OutsideClickHideModal>
  );
}
